import { render, staticRenderFns } from "./Hierarquia.vue?vue&type=template&id=8e8c3e3c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Hierarquia.vue?vue&type=script&lang=js&"
export * from "./Hierarquia.vue?vue&type=script&lang=js&"
import style0 from "./Hierarquia.vue?vue&type=style&index=0&id=8e8c3e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8c3e3c",
  null
  
)

export default component.exports